{
    "order_detail": {
        "back": "Indietro",
        "printOrder": "Stampa ordine",
        "orderTitle": "Ordine",
        "newBadge": "NUOVO",
        "billingAddress": "Indirizzo di fatturazione",
        "shippingAddress": "Indirizzo di spedizione",
        "notes": "Note",
        "requestedDeliveryDate": "Data consegna richiesta",
        "firstAvailableDate": "Prima data disponibile",
        "paymentMethod": "Metodo di Pagamento",
        "itemsSummary": "Riepilogo articoli",
        "unitPrice": "Prezzo unit.",
        "orderSummary": "Riepilogo ordine",
        "items": "articoli",
        "subtotal": "Subtotale",
        "shipping": "Spedizione",
        "vat": "IVA",
        "total": "Totale",
        "customer_ref": "Riferimento cliente"
    },
    "invoice_detail": {
        "back": "Indietro",
        "printInvoice": "Stampa fattura",
        "invoiceTitle": "Fattura",
        "newBadge": "NUOVO",
        "billingAddress": "Indirizzo di fatturazione",
        "shippingAddress": "Indirizzo di spedizione",
        "orderNumber": "Numero Ordine",
        "paymentMethod": "Metodo di Pagamento",
        "itemsSummary": "Riepilogo articoli",
        "unitPrice": "Prezzo unit.",
        "invoiceSummary": "Riepilogo fattura",
        "items": "articoli",
        "subtotal": "Subtotale",
        "shipping": "Spedizione",
        "vat": "IVA",
        "total": "Totale"
    },
    "ddt_detail": {
        "back": "Indietro",
        "printDdt": "Stampa DDT",
        "ddtTitle": "DDT",
        "newBadge": "NUOVO",
        "billingAddress": "Indirizzo di fatturazione",
        "shippingAddress": "Indirizzo di spedizione",
        "orderNumber": "Numero Ordine",
        "paymentTerm": "Termini di pagamento",
        "dueDate": "Data scadenza",
        "invoiceDate": "Data fattura",
        "postingDate": "Data registrazione",
        "itemsSummary": "Riepilogo articoli",
        "quantity": "Quantità: ",
        "shipmentDate": "Data spedizione: ",
        "ddtSummary": "Riepilogo DDT",
        "items": "articoli"
    },
    "credit_note_detail": {
        "back": "Indietro",
        "printCreditNote": "Stampa nota di credito",
        "creditNoteTitle": "Nota di Credito",
        "newBadge": "NUOVO",
        "billingAddress": "Indirizzo di fatturazione",
        "sellingAddress": "Indirizzo di vendita",
        "invoiceNumber": "Numero Fattura",
        "itemsSummary": "Riepilogo articoli",
        "unitPrice": "Prezzo unit.",
        "creditNoteSummary": "Riepilogo nota di credito",
        "items": "articoli",
        "subtotal": "Subtotale",
        "total": "Totale"
    },
    "account_area": {
        "orders": {
            "no_orders": "Non ci sono ordini.",
            "table": {
                "order_number": "Ordine N.",
                "date": "Data",
                "order_status": "Stato",
                "shipping_date": "Data di spedizione",
                "total_price": "Totale"
            }
        },
        "invoices": {
            "no_invoices": "Non ci sono fatture.",
            "no_invoice": "Non ci sono fatture.",
            "table": {
                "invoice_number": "Fattura N.",
                "date": "Data",
                "description": "Descrizione",
                "tax": "Tasse",
                "total": "Totale",
                "status": "Stato",
                "order_number": "Ordine N.",
                "amount_excluding_tax": "Importo escl. IVA",
                "amount_including_tax": "Importo incl. IVA"
            }
        },
        "ddts": {
            "no_ddts": "Non ci sono DDT.",
            "no_ddt": "Non ci sono DDT.",
            "table": {
                "ddt_number": "DDT N.",
                "invoice_date": "Data fattura",
                "posting_date": "Data registrazione",
                "due_date": "Data scadenza",
                "order_number": "Ordine N.",
                "payment_term": "Termini di pagamento"
            }
        },
        "credit_notes": {
            "no_credit_notes": "Non ci sono note di credito.",
            "table": {
                "credit_note_number": "Nota di credito N.",
                "date": "Data",
                "status": "Stato",
                "invoice_number": "Fattura N.",
                "amount_excluding_tax": "Importo escl. IVA",
                "amount_including_tax": "Importo incl. IVA"
            }
        },
        "downloads": {
            "no_downloads": "Non ci sono file.",
            "no_download": "Non ci sono file.",
            "categories": {
                "title": "Area Download",
                "back": "← Indietro",
                "select_category": "Seleziona una categoria"
            },
            "table": {
                "file_name": "Nome file",
                "date": "Data",
                "description": "Descrizione"
            }
        }
    },
    "b2b_store": {
        "no_items": "Nessun prodotto disponibile nello store.",
        "subtotal_label": "Articoli totali",
        "total_label": "Quantità finale",
        "go_to_checkout_label_btn": "Procedi con l'ordine"
    },
    "b2b_send_order": {
        "shipping_and_payment": "Spedizione e pagamento",
        "billing_address": "Indirizzo di fatturazione",
        "payment_method": "Metodo di pagamento",
        "shipping_address": "Indirizzo di spedizione",
        "items_summary": "Riepilogo articoli",
        "product": "Prodotto",
        "unit_price": "Prezzo unitario",
        "pieces_short": "pz",
        "order_summary": "Riepilogo ordine",
        "items": "articoli",
        "subtotal": "Articoli totali",
        "total": "Quantità finale",
        "requested_delivery": "Consegna richiesta",
        "first_available_date": "Prima data possibile",
        "exact_date": "Data precisa",
        "exact_date_help": "Inserisci la data in cui vorresti che ti suo ordine fosse consegnato",
        "date_placeholder": "gg/mm/aaaa",
        "additional_info": "Informazioni aggiuntive",
        "additional_info_help": "Inserisci il tuo riferimento e/o una nota d'ordine se necessario",
        "customer_reference_placeholder": "Riferimento cliente",
        "order_note_placeholder": "Nota dell'ordine",
        "send_order": "Invia ordine",
        "back_to_store": "← Torna a B2B Store",
        "error_address": "ATTENZIONE: Non sono presenti indirizzi di spedizione e/o fatturazione",
        "error_send_order": "C'è stato un errore nell'invio dell'ordine"
    },
    "b2b_customer_data_checks": {
        "error_title": "Dati cliente mancanti",
        "error_message": "Non sono stati trovati i dati necessari per procedere con l'ordine B2B. Si prega di assicurarsi di essere loggati come cliente B2B e che il profilo contenga almeno un indirizzo valido."
    },
    "order_status": {
        "new": "Nuovo",
        "complete": "Spedito",
        "approved": "Approvato",
        "New": "Nuovo",
        "Processing": "In lavorazione",
        "Imported": "Da Approvare",
        "Error": "Errore",
        "Blocked": "Bloccato",
        "Canceled": "Cancellato",
        "ToApprove": "Da approvare",
        "Approved": "Approvato",
        "Open": "Aperto",
        "Pending": "Approvato"
    },
    "general": {
        "button_paginator_label": "Carica altri"
    },
    "rma_form": {
        "error_submit": "Errore nell'invio del RMA, assicurati di aver compilato correttamente tutti i campi.",
        "error_load_ddt": "Non è stato possibile caricare i dati del DDT",
        "error_missing_data": "Mancano dei dati per poter compilare l'RMA",
        "vat_label": "P.IVA",
        "serial_number_label": "Numero Seriale",
        "quantity_number_label": "Quantità prodotto, massimo numero di pezzi: ",
        "reason_label": "Motivo",
        "submit_button": "Invia Reclamo",
        "error_load_row": "Non sono stati trovati prodotti per questo DDT",
        "error_load_ddt_details": "Errore nel caricamento dei dati di dettaglio del DDT"
    }
}
